(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // --- Iron Tailor desktop mega/dropdown open+close (hover on pointer
  // devices, click/tap + keyboard otherwise). Purely desktop-scope: mobile
  // uses Dawn's own header-drawer/menu-drawer.js, untouched.
  //
  // IMPORTANT: the Liquid "javascript" block tag is compiled by Shopify
  // into a static, deduplicated asset file — it does NOT run Liquid
  // templating, unlike the "style" block tag. A previous version of this
  // script used a section-id-based selector built from a Liquid variable,
  // which shipped to the browser as literal, un-substituted text and threw
  // a hard SyntaxError on the resulting invalid selector — which silently
  // killed this ENTIRE script (including the sticky-header class below it),
  // so nothing in here ever ran. Fixed by scoping via a stable class
  // selector instead of a Liquid-generated ID; there's only ever one header
  // per page, so this needs no per-section scoping anyway, and it now
  // correctly handles every nav found on the page. ---
  document.querySelectorAll('.it-desktop-nav').forEach(function (root) {
    var subItems = root.querySelectorAll('.it-nav-li[data-submenu="true"]');
    if (!subItems.length) return;
    var hoverCapable = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    // .it-mega is position:fixed (see CSS comment above for why), so its
    // `top` has to be set at runtime to match wherever the header's bottom
    // edge actually is right now — this changes with sticky-header state,
    // transparent-over-hero vs scrolled-past, and window resizing, so it's
    // recalculated on every open plus on resize/scroll while one is open.
    var headerEl = document.querySelector('.section-header');

    function positionOpenMega() {
      if (!headerEl) return;
      var openLi = root.querySelector('.it-nav-li.open');
      if (!openLi) return;
      var mega = openLi.querySelector(':scope > .it-mega');
      if (!mega) return;
      mega.style.top = headerEl.getBoundingClientRect().bottom + 'px';
    }

    function closeAll() {
      subItems.forEach(function (li) {
        li.classList.remove('open');
        var trigger = li.querySelector('a[aria-haspopup]');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      });
    }

    subItems.forEach(function (li) {
      var trigger = li.querySelector('a[aria-haspopup]');
      if (hoverCapable) {
        li.addEventListener('mouseenter', function () {
          closeAll();
          li.classList.add('open');
          if (trigger) trigger.setAttribute('aria-expanded', 'true');
          positionOpenMega();
        });
        li.addEventListener('mouseleave', function () {
          li.classList.remove('open');
          if (trigger) trigger.setAttribute('aria-expanded', 'false');
        });
      } else if (trigger) {
        trigger.addEventListener('click', function (e) {
          var isOpen = li.classList.contains('open');
          e.preventDefault();
          closeAll();
          li.classList.toggle('open', !isOpen);
          trigger.setAttribute('aria-expanded', String(!isOpen));
          if (!isOpen) positionOpenMega();
        });
      }
    });

    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) closeAll();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll();
    });
    window.addEventListener('resize', positionOpenMega);
    window.addEventListener('scroll', positionOpenMega, { passive: true });
  });

  // --- Custom mobile drawer: open/close + accordion expand/collapse.
  // Built to work identically regardless of how many header instances or
  // drawer toggles exist on the page (matches each toggle to its own panel
  // via aria-controls, same pattern used for the desktop mega/dropdown). ---
  document.querySelectorAll('.it-mdrawer-toggle').forEach(function (toggleBtn) {
    var panelId = toggleBtn.getAttribute('aria-controls');
    var drawer = panelId ? document.getElementById(panelId) : null;
    if (!drawer) return;

    function openDrawer() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      toggleBtn.setAttribute('aria-expanded', 'true');
      document.documentElement.style.overflow = 'hidden';
    }
    function closeDrawer() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      toggleBtn.setAttribute('aria-expanded', 'false');
      document.documentElement.style.overflow = '';
    }

    toggleBtn.addEventListener('click', function () {
      if (drawer.classList.contains('is-open')) { closeDrawer(); } else { openDrawer(); }
    });
    drawer.querySelectorAll('[data-mdrawer-close]').forEach(function (el) {
      el.addEventListener('click', closeDrawer);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });

    // Accordion: tapping a top-level item's chevron expands its panel
    // in place (multiple can be open at once, matching the reference —
    // tap again, or tap a different chevron, to collapse just that one).
    drawer.querySelectorAll('.it-mnav-toggle').forEach(function (btn) {
      var accPanelId = btn.getAttribute('aria-controls');
      var accPanel = accPanelId ? document.getElementById(accPanelId) : null;
      if (!accPanel) return;
      btn.addEventListener('click', function () {
        var isOpen = accPanel.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', String(isOpen));
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["it-boxicon"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initCarousel(section){
    var track = section.querySelector('[data-it-ib-carousel]');
    if(!track) return;
    var prev = section.querySelector('[data-it-ib-prev]');
    var next = section.querySelector('[data-it-ib-next]');
    var dotsWrap = section.querySelector('[data-it-ib-dots]');
    var cards = Array.prototype.slice.call(track.querySelectorAll('.it-ib-box'));
    if(!cards.length) return;

    function isCarouselActive(){
      // Only true horizontal scrolling when the grid has actually switched to flex
      return getComputedStyle(track).display === 'flex' && track.scrollWidth > track.clientWidth + 2;
    }

    function cardStep(){
      var card = track.querySelector('.it-ib-box');
      if(!card) return 300;
      var style = getComputedStyle(track);
      var gap = parseFloat(style.columnGap || style.gap || 0);
      return card.getBoundingClientRect().width + gap;
    }

    function updateButtons(){
      if(!prev || !next) return;
      if(!isCarouselActive()){
        prev.disabled = true;
        next.disabled = true;
        return;
      }
      var maxScroll = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 0;
      next.disabled = track.scrollLeft >= maxScroll;
    }

    var dots = [];
    function buildDots(){
      if(!dotsWrap) return;
      dotsWrap.innerHTML = '';
      dots = cards.map(function(card, i){
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'it-ib-dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        dot.addEventListener('click', function(){
          track.scrollTo({ left: card.offsetLeft - track.offsetLeft, behavior: 'smooth' });
        });
        dotsWrap.appendChild(dot);
        return dot;
      });
    }

    function updateDots(){
      if(!dots.length) return;
      var trackLeft = track.scrollLeft;
      var closestIndex = 0;
      var closestDist = Infinity;
      cards.forEach(function(card, i){
        var dist = Math.abs((card.offsetLeft - track.offsetLeft) - trackLeft);
        if(dist < closestDist){
          closestDist = dist;
          closestIndex = i;
        }
      });
      dots.forEach(function(dot, i){
        dot.classList.toggle('is-active', i === closestIndex);
      });
    }

    var ticking = false;
    function onScroll(){
      updateButtons();
      if(!ticking){
        ticking = true;
        window.requestAnimationFrame(function(){
          updateDots();
          ticking = false;
        });
      }
    }

    if(prev){
      prev.addEventListener('click', function(){
        track.scrollBy({ left: -cardStep(), behavior: 'smooth' });
      });
    }
    if(next){
      next.addEventListener('click', function(){
        track.scrollBy({ left: cardStep(), behavior: 'smooth' });
      });
    }

    track.addEventListener('scroll', onScroll);
    window.addEventListener('resize', function(){
      updateButtons();
      updateDots();
    });

    buildDots();
    updateButtons();
    updateDots();

    // ─── Desktop auto-advance ───
    // Only engages above the 1100px tablet breakpoint, and only when the
    // section rendered the autoplay data attribute (desktop carousel + autoplay both on).
    var autoplaySpeed = parseInt(track.getAttribute('data-it-ib-autoplay'), 10);
    if(autoplaySpeed){
      var autoplayTimer = null;
      var isPaused = false;
      var desktopQuery = window.matchMedia('(min-width: 1101px)');

      function autoplayEligible(){
        return desktopQuery.matches && isCarouselActive();
      }

      function tick(){
        if(isPaused || !autoplayEligible()) return;
        var maxScroll = track.scrollWidth - track.clientWidth - 2;
        if(track.scrollLeft >= maxScroll){
          track.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          track.scrollBy({ left: cardStep(), behavior: 'smooth' });
        }
      }

      function startAutoplay(){
        stopAutoplay();
        if(!autoplayEligible()) return;
        autoplayTimer = setInterval(tick, autoplaySpeed);
      }
      function stopAutoplay(){
        if(autoplayTimer) clearInterval(autoplayTimer);
        autoplayTimer = null;
      }

      section.addEventListener('mouseenter', function(){ isPaused = true; });
      section.addEventListener('mouseleave', function(){ isPaused = false; });
      track.addEventListener('touchstart', function(){ isPaused = true; }, { passive: true });
      track.addEventListener('touchend', function(){ isPaused = false; }, { passive: true });
      if(prev){ prev.addEventListener('click', function(){ isPaused = true; }); }
      if(next){ next.addEventListener('click', function(){ isPaused = true; }); }

      window.addEventListener('resize', startAutoplay);
      startAutoplay();
    }
  }

  function initAll(root){
    (root || document).querySelectorAll('.it-ib').forEach(function(section){
      initCarousel(section);
    });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function(e){ initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["it-custom-order"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initCuf(root){
    var addBtn = root.querySelector('[data-cuf-add-to-cart]');
    if(!addBtn) return;
    addBtn.addEventListener('click', function(){
      if(addBtn.disabled) return;
      var label = addBtn.dataset.label || addBtn.textContent;
      addBtn.disabled = true;
      addBtn.classList.remove('is-added', 'is-error');
      addBtn.classList.add('is-loading');
      addBtn.textContent = 'Adding...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: addBtn.dataset.variantId, quantity: 1 }] })
      })
        .then(function(r){ if(!r.ok) throw new Error('Add to cart failed'); return r.json(); })
        .then(function(){
          addBtn.classList.remove('is-loading');
          addBtn.classList.add('is-added');
          addBtn.textContent = 'Added ✓';
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          setTimeout(function(){
            addBtn.classList.remove('is-added');
            addBtn.textContent = label;
            addBtn.disabled = false;
          }, 2000);
        })
        .catch(function(err){
          console.error('IT custom order form add-to-cart error', err);
          addBtn.classList.remove('is-loading');
          addBtn.classList.add('is-error');
          addBtn.textContent = 'Try Again';
          addBtn.disabled = false;
          setTimeout(function(){
            addBtn.classList.remove('is-error');
            addBtn.textContent = label;
          }, 2000);
        });
    });
  }
  function initAll(root){
    (root || document).querySelectorAll('.it-cuf').forEach(initCuf);
  }
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function(e){ initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["it-faq"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initFaq(root){
    var list = root.querySelector('[data-it-faq]');
    if(!list || list.dataset.singleOpen !== 'true') return;
    var items = list.querySelectorAll('.it-faq-item');
    items.forEach(function(item){
      item.addEventListener('toggle', function(){
        if(!item.open) return;
        items.forEach(function(other){
          if(other !== item) other.removeAttribute('open');
        });
      });
    });
  }
  function initAll(root){
    (root || document).querySelectorAll('.it-faq-section').forEach(initFaq);
  }
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function(e){ initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["it-genders"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initVideos(root){
    var wraps = (root || document).querySelectorAll('.it-gc-video-wrap[data-autoplay="true"]');
    if(!wraps.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        var video = entry.target.querySelector('video');
        if(!video) return;
        if(entry.isIntersecting){
          video.play().catch(function(){});
        } else {
          video.pause();
        }
      });
    }, { threshold: 0.25 });
    wraps.forEach(function(w){ io.observe(w); });
  }
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ initVideos(); });
  } else {
    initVideos();
  }
  document.addEventListener('shopify:section:load', function(e){ initVideos(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["it-icon"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initCarousel(section){
    var track = section.querySelector('[data-it-ib-carousel]');
    if(!track) return;
    var prev = section.querySelector('[data-it-ib-prev]');
    var next = section.querySelector('[data-it-ib-next]');
    var dotsWrap = section.querySelector('[data-it-ib-dots]');
    var cards = Array.prototype.slice.call(track.querySelectorAll('.it-ib-box'));
    if(!cards.length) return;

    function isCarouselActive(){
      // Only true horizontal scrolling when the grid has actually switched to flex
      return getComputedStyle(track).display === 'flex' && track.scrollWidth > track.clientWidth + 2;
    }

    function cardStep(){
      var card = track.querySelector('.it-ib-box');
      if(!card) return 300;
      var style = getComputedStyle(track);
      var gap = parseFloat(style.columnGap || style.gap || 0);
      return card.getBoundingClientRect().width + gap;
    }

    function updateButtons(){
      if(!prev || !next) return;
      if(!isCarouselActive()){
        prev.disabled = true;
        next.disabled = true;
        return;
      }
      var maxScroll = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 0;
      next.disabled = track.scrollLeft >= maxScroll;
    }

    var dots = [];
    function buildDots(){
      if(!dotsWrap) return;
      dotsWrap.innerHTML = '';
      dots = cards.map(function(card, i){
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'it-ib-dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        dot.addEventListener('click', function(){
          track.scrollTo({ left: card.offsetLeft - track.offsetLeft, behavior: 'smooth' });
        });
        dotsWrap.appendChild(dot);
        return dot;
      });
    }

    function updateDots(){
      if(!dots.length) return;
      var trackLeft = track.scrollLeft;
      var closestIndex = 0;
      var closestDist = Infinity;
      cards.forEach(function(card, i){
        var dist = Math.abs((card.offsetLeft - track.offsetLeft) - trackLeft);
        if(dist < closestDist){
          closestDist = dist;
          closestIndex = i;
        }
      });
      dots.forEach(function(dot, i){
        dot.classList.toggle('is-active', i === closestIndex);
      });
    }

    var ticking = false;
    function onScroll(){
      updateButtons();
      if(!ticking){
        ticking = true;
        window.requestAnimationFrame(function(){
          updateDots();
          ticking = false;
        });
      }
    }

    if(prev){
      prev.addEventListener('click', function(){
        track.scrollBy({ left: -cardStep(), behavior: 'smooth' });
      });
    }
    if(next){
      next.addEventListener('click', function(){
        track.scrollBy({ left: cardStep(), behavior: 'smooth' });
      });
    }

    track.addEventListener('scroll', onScroll);
    window.addEventListener('resize', function(){
      updateButtons();
      updateDots();
    });

    buildDots();
    updateButtons();
    updateDots();
  }

  function initAll(root){
    (root || document).querySelectorAll('.it-ib').forEach(function(section){
      initCarousel(section);
    });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function(e){ initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["it-journal"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initCarousel(section){
    var track = section.querySelector('[data-it-carousel]');
    if(!track) return;
    var prev = section.querySelector('[data-carousel-prev]');
    var next = section.querySelector('[data-carousel-next]');
    var dotsWrap = section.querySelector('[data-it-dots]');
    var cards = Array.prototype.slice.call(track.querySelectorAll('.it-ins-card'));

    function cardStep(){
      var card = track.querySelector('.it-ins-card');
      if(!card) return 300;
      var style = getComputedStyle(track);
      var gap = parseFloat(style.columnGap || style.gap || 0);
      return card.getBoundingClientRect().width + gap;
    }

    function updateButtons(){
      if(!prev || !next) return;
      var maxScroll = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 0;
      next.disabled = track.scrollLeft >= maxScroll;
    }

    // Build dots — one per card, active dot tracks whichever card is closest to the track's left edge
    var dots = [];
    function buildDots(){
      if(!dotsWrap) return;
      dotsWrap.innerHTML = '';
      dots = cards.map(function(card, i){
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'it-ins-dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        dot.addEventListener('click', function(){
          track.scrollTo({ left: card.offsetLeft - track.offsetLeft, behavior: 'smooth' });
        });
        dotsWrap.appendChild(dot);
        return dot;
      });
    }

    function updateDots(){
      if(!dots.length) return;
      var trackLeft = track.scrollLeft;
      var closestIndex = 0;
      var closestDist = Infinity;
      cards.forEach(function(card, i){
        var dist = Math.abs((card.offsetLeft - track.offsetLeft) - trackLeft);
        if(dist < closestDist){
          closestDist = dist;
          closestIndex = i;
        }
      });
      dots.forEach(function(dot, i){
        dot.classList.toggle('is-active', i === closestIndex);
      });
    }

    var scrollTicking = false;
    function onScroll(){
      updateButtons();
      if(!scrollTicking){
        scrollTicking = true;
        window.requestAnimationFrame(function(){
          updateDots();
          scrollTicking = false;
        });
      }
    }

    if(prev){
      prev.addEventListener('click', function(){
        track.scrollBy({ left: -cardStep(), behavior: 'smooth' });
      });
    }
    if(next){
      next.addEventListener('click', function(){
        track.scrollBy({ left: cardStep(), behavior: 'smooth' });
      });
    }

    track.addEventListener('scroll', onScroll);
    window.addEventListener('resize', function(){
      updateButtons();
      updateDots();
    });

    buildDots();
    updateButtons();
    updateDots();
  }

  function initAll(root){
    (root || document).querySelectorAll('.it-section').forEach(function(section){
      initCarousel(section);
    });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function(e){ initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["it-shops-bycategory"] && !Shopify.designMode) return;
  try {
    
(function(){
  function currentPerView(outer){
    var w      = window.innerWidth;
    var styles = getComputedStyle(outer);
    var key    = w >= 990 ? '--it-items-desktop' : (w >= 768 ? '--it-items-tablet' : '--it-items-mobile');
    return parseFloat(styles.getPropertyValue(key)) || 1;
  }

  function itemStep(scroll, items){
    var gap = parseFloat(getComputedStyle(scroll).gap) || 0;
    return items[0].getBoundingClientRect().width + gap;
  }

  function isGridMode(scroll){
    return getComputedStyle(scroll).flexWrap === 'wrap';
  }

  function initCarousel(outer){
    var scroll = outer.querySelector('.it-circ-scroll');
    if(!scroll) return;
    var items  = scroll.querySelectorAll('.it-circ-item');
    if(!items.length) return;

    var prev      = outer.querySelector('.it-circ-arrow--prev');
    var next      = outer.querySelector('.it-circ-arrow--next');
    var sectionEl = outer.closest('.it-section');
    var dotsWrap  = sectionEl ? sectionEl.querySelector('.it-circ-dots') : null;
    var autoTimer = null;

    function updateArrows(){
      if(!prev || !next) return;
      if(isGridMode(scroll)){
        prev.style.display = 'none';
        next.style.display = 'none';
        return;
      }
      prev.style.display = '';
      next.style.display = '';
      prev.disabled = scroll.scrollLeft <= 4;
      next.disabled = scroll.scrollLeft >= (scroll.scrollWidth - scroll.clientWidth - 4);
    }

    function activeIndex(){
      return Math.round(scroll.scrollLeft / itemStep(scroll, items));
    }

    function rebuildDots(){
      if(!dotsWrap) return;
      if(isGridMode(scroll)){ dotsWrap.style.display = 'none'; return; }
      dotsWrap.style.display = '';
      var perView  = currentPerView(outer);
      var dotCount = Math.max(1, Math.ceil(items.length / perView));
      dotsWrap.innerHTML = '';
      for(var i = 0; i < dotCount; i++){
        (function(idx){
          var b = document.createElement('button');
          b.type      = 'button';
          b.className = 'it-circ-dot' + (idx === 0 ? ' is-active' : '');
          b.setAttribute('aria-label', 'Go to slide ' + (idx + 1));
          b.addEventListener('click', function(){
            scroll.scrollTo({ left: idx * itemStep(scroll, items) * perView, behavior: 'smooth' });
          });
          dotsWrap.appendChild(b);
        })(i);
      }
      updateDots();
    }

    function updateDots(){
      if(!dotsWrap || isGridMode(scroll)) return;
      var dots    = dotsWrap.querySelectorAll('.it-circ-dot');
      if(!dots.length) return;
      var perView = currentPerView(outer);
      var idx     = Math.min(Math.round(activeIndex() / perView), dots.length - 1);
      dots.forEach(function(d, i){ d.classList.toggle('is-active', i === idx); });
    }

    if(prev) prev.addEventListener('click', function(){
      scroll.scrollBy({ left: -itemStep(scroll, items) * currentPerView(outer), behavior: 'smooth' });
    });
    if(next) next.addEventListener('click', function(){
      scroll.scrollBy({ left:  itemStep(scroll, items) * currentPerView(outer), behavior: 'smooth' });
    });

    /* Mouse-drag */
    var isDown = false, startX = 0, startScroll = 0;
    scroll.addEventListener('mousedown', function(e){
      if(isGridMode(scroll)) return;
      isDown = true; scroll.classList.add('is-dragging');
      startX = e.pageX; startScroll = scroll.scrollLeft;
      if(autoTimer) clearInterval(autoTimer);
    });
    window.addEventListener('mouseup', function(){
      if(!isDown) return;
      isDown = false; scroll.classList.remove('is-dragging');
    });
    window.addEventListener('mousemove', function(e){
      if(!isDown) return;
      e.preventDefault();
      scroll.scrollLeft = startScroll - (e.pageX - startX);
    });

    scroll.addEventListener('scroll', function(){
      window.requestAnimationFrame(function(){ updateArrows(); updateDots(); });
    }, { passive: true });

    var resizeTimer;
    window.addEventListener('resize', function(){
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function(){ rebuildDots(); updateArrows(); }, 150);
    });

    updateArrows();
    rebuildDots();

    /* Autoplay */
    var autoplay = sectionEl && sectionEl.dataset.autoplay === 'true';
    var speed    = (sectionEl && parseInt(sectionEl.dataset.autoplaySpeed, 10)) || 4000;
    if(autoplay){
      autoTimer = setInterval(function(){
        if(isGridMode(scroll)) return;
        if(scroll.scrollLeft >= scroll.scrollWidth - scroll.clientWidth - 4){
          scroll.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          scroll.scrollBy({ left: itemStep(scroll, items), behavior: 'smooth' });
        }
      }, speed);
      outer.addEventListener('mouseenter', function(){ if(autoTimer) clearInterval(autoTimer); });
    }
  }

  function initAll(root){
    (root || document).querySelectorAll('.it-circ-outer').forEach(initCarousel);
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function(e){ initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["it-split"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initEmbed(section){
    var wrap = section.querySelector('.it-sp-embed-wrap[data-embed-src]');
    if(!wrap) return;
    var src = wrap.dataset.embedSrc;
    if(src.indexOf('mute=') === -1) src += (src.indexOf('?') > -1 ? '&' : '?') + 'mute=1&muted=1';
    var iframe = document.createElement('iframe');
    iframe.src = src;
    iframe.style.position = 'absolute';
    iframe.style.inset = '0';
    iframe.allow = 'autoplay; fullscreen; picture-in-picture';
    iframe.allowFullscreen = true;
    iframe.className = 'it-sp-lightbox-iframe';
    wrap.appendChild(iframe);
  }

  function initSplit(section){
    initEmbed(section);
    var trigger = section.querySelector('.it-sp-img[data-lightbox]');
    var modal = section.querySelector('.it-sp-lightbox');
    if(!trigger || !modal) return;

    var embed = modal.querySelector('.it-sp-lightbox-embed');
    var video = modal.querySelector('.it-sp-lightbox-media');
    var closeEls = modal.querySelectorAll('[data-close]');

    function open(){
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      if(embed && embed.dataset.embedSrc){
        var iframe = document.createElement('iframe');
        iframe.src = embed.dataset.embedSrc;
        iframe.allow = 'autoplay; fullscreen; picture-in-picture';
        iframe.allowFullscreen = true;
        iframe.className = 'it-sp-lightbox-iframe';
        embed.innerHTML = '';
        embed.appendChild(iframe);
      }
      if(video){ video.play().catch(function(){}); }
    }

    function close(){
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      if(embed) embed.innerHTML = '';
      if(video){ video.pause(); video.currentTime = 0; }
    }

    trigger.addEventListener('click', open);
    closeEls.forEach(function(el){ el.addEventListener('click', close); });
    document.addEventListener('keydown', function(e){
      if(e.key === 'Escape' && modal.classList.contains('is-open')) close();
    });
  }

  function initAll(root){
    (root || document).querySelectorAll('.it-section').forEach(function(section){
      if(section.querySelector('.it-split')) initSplit(section);
    });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function(e){ initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
